module.exports = __webpack_public_path__ + "static/media/ripley-communication-slide-2.9266b4e8.jpg";